import AmazonReferralBanner from "../../../components/admin/Dashboard/AmazonReferralBanner";
import PaymentReferencesHubSection from "../../../components/admin/Dashboard/PaymentReferencesHubSection";
import PaymentReferenceDashboard from "../../../components/admin/Dashboard/PaymentReferenceDashboard";
import { ReactComponent as Spinner } from "../../../assets/icons/orangeSpinner.svg";
import { useGetAssignedReferenceRequestsQuery } from "../../../store/Company/companyApiSlice";
import { useSelector } from "react-redux";

function PaymentRefHub() {
  const { token } = useSelector((state) => state.auth);

  const {
    data: requestReferenceData,
    isLoading,
    isError,
    error
  } = useGetAssignedReferenceRequestsQuery(token,
    {
      skip: !token,
      refetchOnMountOrArgChange: true,
    }
  );

  /* ---------------- LOADING STATE ---------------- */
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Spinner className="w-10 h-10 animate-spin" />
      </div>
    );
  }

  /* ---------------- ERROR STATE ---------------- */
  if (isError) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <div className="p-4 rounded-lg bg-red-50 border border-red-300 text-red-700 text-sm">
          {error?.data?.message ||
            error?.error ||
            "Failed to load payment reference data."}
        </div>
      </div>
    );
  }

  /* ---------------- EMPTY STATE ---------------- */
  const isEmpty =
    !requestReferenceData ||
    (Array.isArray(requestReferenceData) &&
      requestReferenceData.length === 0);

  return (
    <div className="flex flex-col gap-3">
      {/* HEADER SECTION */}
      <PaymentReferencesHubSection />

      {/* BANNER */}
      <AmazonReferralBanner />

      {/* DASHBOARD / EMPTY STATE */}
      {isEmpty ? (
        <div className="bg-white border border-[#D0D5DD] rounded-xl p-6 text-center text-sm text-gray-600">
          No payment reference requests assigned yet.
        </div>
      ) : (
        <PaymentReferenceDashboard data={requestReferenceData} />
      )}
    </div>
  );
}

export default PaymentRefHub;
